<template>
  <app-modal>
    <el-card class="box-card" v-if="show">
      <el-form
        @submit.native.prevent="saveEntrada"
        ref="form"
        label-position="top"
        id="image"
        v-if="show"
      >
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
              <el-input v-model="documento.title"></el-input>
              <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
            </el-form-item>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item label="Fecha para publicar">
              <el-date-picker
                v-model="documento.date"
                type="date"
                placeholder="Fecha para publicar"
                format="dd/MM/yyyy"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="¿Confirmacion leido?">
              <el-switch v-model="documento.check_leido" :active-value="'1'" :inactive-value="'2'"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="Selecciona el tipo de documento">
              <select class="select" v-model="documento.tipo">
                <option
                  v-for="(item, index) in tipeDoc"
                  :key="index"
                  :value="item.id"
                >{{item.title}}</option>
              </select>
            </el-form-item>
          </el-col>

          <el-col :span="11">
            <el-form-item label="Descripción breve (máx. 150 carácteres)">
              <el-input type="textarea" v-model="documento.description"></el-input>
              <div v-if="errorText" class="el-form-item__error">Ha superado los 150 carácteres</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="Archivo">
              <el-upload
                class="upload-demo"
                id="file"
                ref="file"
                action
                :auto-upload="false"
                :multiple="false"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-preview="handlePreview"
                :on-exceed="handleExceed"
                :file-list="file"
                :file="file"
                :limit="1"
              >
                <el-button size="small" type="primary">Clic para cargar archivo</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="Enlace interno de Intranet">
              <el-input v-model="documento.link"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!--el-row>
          <el-form-item label="Imagen">
            <app-cropper :options="options"></app-cropper>
          </el-form-item>
        </el-row-->

        <el-row>
          <el-col :span="24">
            <button type="submit" class="el-button el-button--primary">
              <span>{{btn}}</span>
            </button>
            <el-button @click="closeModal()">Cerrar</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </app-modal>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Cropper from "@/components/Dashboard/commons/cropper.vue";
import Modal from "@/components/Dashboard/Modals/modal";
import moment from "moment-timezone";

export default {
  name: "addDocumento",
  props: ["content", "documentoId"],
  components: {
    "app-modal": Modal,
    "app-cropper": Cropper
  },
  created() {
    this.documentoId ? this.getEntrada() : (this.show = true);
  },
  data() {
    return {
      btn: "Añadir",
      documento: {
        title: "",
        description: "",
        url: null,
        file: [],
        link: "",
        date: "",
        tipo: 1
      },
      file: [],
      options: {
        img: null,
        size: 1,
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        class: "cropper-medium",
        info: true,
        canScale: true,
        autoCrop: true,
        autoCropHeight: 500,
        autoCropWidth: 600,
        fixed: false,
        fixedBox: true,
        centerBox: true,
        fixedNumber: [600, 500]
      },
      errorTitle: false,
      errorText: false,
      showBottons: false,
      show: false,
      api_uploads: API_UPLOADS,
      imageOld: null,
      fileOld: null,
      tipeDoc: [
        {
          id: 1,
          title: "Documento"
        },
        {
          id: 2,
          title: "Procedimiento"
        },
        {
          id: 3,
          title: "Diagrama"
        }
      ],
      pickerOptions1: {
        firstDayOfWeek: 1
      }
    };
  },
  methods: {
    closeModal() {
      this.$root.$emit("closeModal");
    },
    handleRemove(file) {
      this.noImage = true;
      this.file = [];
    },
    handleChange(file) {
      this.file = [file];
      this.noImage = false;
    },
    handleExceed(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        if (!isLt2M) {
          this.$message.error({
            type: "ERROR",
            message: "El documento excede los 10MB y no puede ser cargada!"
          });
          return false;
        }
      }
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },
    async getEntrada() {
      this.btn = "Editar";
      ApiService.post("dashboard/table", {
        table: "documentos",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.documentoId
      }).then(response => {
        this.documento = {
          title: response.data.title,
          description: response.data.description,
          url: response.data.url,
          file: response.data.file,
          link: response.data.link,
          date: response.data.date,
          tipo: response.data.tipo,
          check_leido: response.data.check_leido
        };
        this.file = response.data.file;
        this.imageOld = response.data.url;
        this.fileOld = response.data.file;

        if (response.data.file != 0) {
          let f = {
            name: response.data.file,
            url: this.api_uploads + response.data.file
          };
          this.file = [f];
        } else {
          this.file = [];
        }
        setTimeout(() => {
          this.show = true;
        }, 500);
        this.showBottons = true;
      });
    },
    async saveEntrada() {
      if (this.documento.title.length > 0) {
        if (this.file[0]) {
          if (this.file[0].size) {
            let data = new FormData();
            data.append("file", this.file[0].raw);
            const a = await ApiService.post("upload/documentary", data).then(
              response => {
                this.documento.file = response.data;
              }
            );
          }
        } else {
          if (!this.documento.link) {
            this.$message.error({
              type: "ERROR",
              message:
                "Antes de continuar tienes que adjuntar un documento o un enlace interno!"
            });
            return false;
          }
        }

        this.documento.date = moment(this.documento.date)
          .tz("Europe/Madrid")
          .format("YYYY-MM-DD");
        if (this.documentoId > 0) {
          this.update();
        } else {
          this.insert();
        }
      } else {
        this.$message({
          type: "warning",
          message: "El campo título es obligatorio"
        });
      }
    },
    async insert() {
      if (this.documento.date == "Invalid date") {
        this.documento.date = null;
      }
      ApiService.post("dashboard/editform", {
        table: "documentos",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.documento
      }).then(response => {
        if (response.data != "Algo ha fallado") {
          ApiService.post("dashboard/editform", {
            table: "documental_documentos",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            form: {
              documental_id: this.content,
              documento_id: response.data
            }
          }).then(response => {
            if (response.data != "Algo ha fallado") {
              this.$message({
                type: "success",
                message: "Se ha actualizado el registro"
              });
            } else {
              this.$message({
                type: "warning",
                message: "Algo ha fallado"
              });
            }
          });
        }
      });
    },
    async update() {
      if (this.documento.date == "Invalid date") {
        this.documento.date = null;
      }
      this.documento.date;
      ApiService.post("dashboard/editform", {
        table: "documentos",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.documento,
        id: this.documentoId
      }).then(response => {
        if (response.data != "Algo ha fallado") {
          this.$message({
            type: "success",
            message: "Se ha actualizado el registro"
          });
        } else {
          this.$message({
            type: "warning",
            message: "Algo ha fallado"
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Modals/addDocumento.vue